import React from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';

import styled from 'styled-components';
import Note from './note';

const NotesListContainer = styled.div`
  margin-top: 0px;
  margin-bottom: -14px;
`;

export const Notes = (props) => (
  <NotesListContainer>
    {props.notes.map(
      (note) =>
        !note.parent && <Note key={note.id || uuidV4()} update={props.update} nota={note} delete={props.delete} />
    )}
  </NotesListContainer>
);

Notes.propTypes = {
  notes: PropTypes.array,
  update: PropTypes.func,
  delete: PropTypes.func,
};

export default Notes;



// WEBPACK FOOTER //
// ./app/components/Note/notes.js